import { createContext, useContext } from 'react';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import memoizeOne from 'react-utils/memoizeOne';
import { jsx as _jsx } from "react/jsx-runtime";
export function isHubspotDefined(objectTypeDefinition) {
  return objectTypeDefinition.metaTypeId === 0;
}
export function isIntegrationDefined(objectTypeDefinition) {
  return objectTypeDefinition.metaTypeId === 1;
}
export function isPortalDefined(objectTypeDefinition) {
  return objectTypeDefinition.metaTypeId === 2;
}
export function isCustomObject(objectTypeDefinition) {
  return isPortalDefined(objectTypeDefinition) || isIntegrationDefined(objectTypeDefinition);
}
export const parseObjectTypeDefRecords = memoizeOne(allObjectTypes => {
  const result = new Map();
  allObjectTypes.forEach(typeDef => {
    var _typeDef$primaryDispl;
    const objectTypeId = typeDef.objectTypeId;
    const isContact = objectTypeId === CONTACT_TYPE_ID;
    return result.set(objectTypeId, Object.assign({}, typeDef, {
      objectTypeId,
      // HACK: We have a fake FE-only 'name' property that we use as a contact's primary display label.
      // This property is a combination of 'firstname', 'lastname', and 'email'. The label property marked
      // on the typeDef is just 'firstname', so we overwrite it to avoid confusing the system.
      primaryDisplayLabelPropertyName: isContact ? 'name' : (_typeDef$primaryDispl = typeDef.primaryDisplayLabelPropertyName) !== null && _typeDef$primaryDispl !== void 0 ? _typeDef$primaryDispl : null
    }));
  });
  return result;
});
const ObjectTypeDefinitionsContext = /*#__PURE__*/createContext(null);
export const ProvideObjectTypeDefinitions = ({
  rawValue,
  children
}) => /*#__PURE__*/_jsx(ObjectTypeDefinitionsContext.Provider, {
  value: parseObjectTypeDefRecords(rawValue),
  children: children
});
export const useObjectTypeDefinitions = () => useContext(ObjectTypeDefinitionsContext);